export const LOYALTY_POINT_STATUS = 'LOYALTY_POINT_STATUS'
export const LOYALTY_POINT_HISTORY = 'LOYALTY_POINT_HISTORY'
export const LOYALTY_POINT_WITHDRAW = 'LOYALTY_POINT_WITHDRAW'
